import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="transparent"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.5"
    {...props}
  >
    <path d="M3.66667 10.6654C2.19391 10.6654 1 9.47146 1 7.9987C1 6.72733 1.88971 5.66377 3.08047 5.39667C3.02779 5.16133 3 4.91659 3 4.66536C3 2.82442 4.49238 1.33203 6.33333 1.33203C7.9462 1.33203 9.29153 2.47753 9.60012 3.99935C9.62225 3.99892 9.64443 3.9987 9.66667 3.9987C11.5076 3.9987 13 5.49108 13 7.33203C13 8.94467 11.8548 10.2898 10.3333 10.5987M9 8.66536L7 6.66536M7 6.66536L5 8.66536M7 6.66536L7 14.6654" />
  </svg>
);
